import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';
import { UseInfiniteFeedProps } from './useInfiniteFeed.types';
import { useFeedData } from './useFeedData';

/**
 * Комбинированный хук для бесконечной подгрузки данных в ленту
 * Объединяет useInfiniteScroll и useFeedData для удобного использования
 * @param pageSize - Количество элементов на одной странице
 * @param threshold - Расстояние от низа страницы для начала загрузки
 * @param instanceId - id для того чтобы генерировать рпавильный хеш при использовании нескольких инстансов
 * @returns Объект с данными промптов и методами для управления бесконечной подгрузкой
 */

export const useInfiniteFeed = ({ pageSize = 20, threshold = 200, categories, instanceId }: UseInfiniteFeedProps) => {
    const { prompts, courses, challenges, loading, hasMore, loadMore, reset } = useFeedData(
        pageSize,
        categories,
        instanceId,
    );

    const { loadMore: scrollLoadMore, containerRef } = useInfiniteScroll(loadMore, {
        threshold,
        enabled: true,
        hasMore,
        loading,
    });

    return {
        prompts,
        courses,
        challenges,
        loading: loading,
        hasMore: hasMore,
        loadMore: scrollLoadMore,
        reset,
        containerRef,
    };
};
